import React, { forwardRef } from "react";
import { FormControlLabel, Checkbox } from "@mui/material";

export default forwardRef(function CustomCheckbox(props, ref) {
  return <FormControlLabel ref={ref} control={<Checkbox />} {...props} />;
});
